<template>
  <v-container>
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Edit NPC</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="UpdateNPC()">Save</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-form ref="NewNPC" class="pa-4">
        <v-row>
          <v-col col="12" md="4">
            <v-text-field v-model="newNPC.Name" label="Name" outlined></v-text-field>
          </v-col>
          <v-col col="12" md="1">
            <v-text-field v-model="newNPC.Age" label="Age" outlined></v-text-field>
          </v-col>
          <v-col col="12" md="3">
            <v-text-field v-model="newNPC.Race" label="Race" outlined></v-text-field>
          </v-col>
          <v-col col="12" md="3">
            <v-text-field v-model="newNPC.Occupation" label="Occupation" outlined></v-text-field>
          </v-col>
          <v-col col="12" md="1">
            <v-checkbox v-model="newNPC.Public" label="Public"></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col col="12" md="12">
            <v-textarea rows="2" v-model="newNPC.Description" label="Description" outlined></v-textarea>
          </v-col>
        </v-row>
        <v-row v-if="newNPC.Abilities">
          <v-col col="12" md="2">
            <v-text-field v-model="newNPC.Abilities.str" label="Strength" outlined></v-text-field>
          </v-col>
          <v-col col="6" md="2">
            <v-text-field v-model="newNPC.Abilities.dex" label="Dexterity" outlined></v-text-field>
          </v-col>
          <v-col col="6" md="2">
            <v-text-field v-model="newNPC.Abilities.con" label="Constitution" outlined></v-text-field>
          </v-col>
          <v-col col="6" md="2">
            <v-text-field v-model="newNPC.Abilities.int" label="Intellect" outlined></v-text-field>
          </v-col>
          <v-col col="6" md="2">
            <v-text-field v-model="newNPC.Abilities.wis" label="Wisdom" outlined></v-text-field>
          </v-col>
          <v-col col="6" md="2">
            <v-text-field v-model="newNPC.Abilities.cha" label="Charisma" outlined></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="newNPC.Alignment">
          <v-col col="12" md="2">
            <v-text-field v-model="newNPC.Alignment.good" label="Good" outlined></v-text-field>
          </v-col>
          <v-col col="6" md="2">
            <v-text-field v-model="newNPC.Alignment.moralneutral" label="Moralne Neutral" outlined></v-text-field>
          </v-col>
          <v-col col="6" md="2">
            <v-text-field v-model="newNPC.Alignment.evil" label="Evil" outlined></v-text-field>
          </v-col>
          <v-col col="6" md="2">
            <v-text-field v-model="newNPC.Alignment.lawful" label="Lawful" outlined></v-text-field>
          </v-col>
          <v-col col="6" md="2">
            <v-text-field
              v-model="newNPC.Alignment.ethicalneutral"
              label="Ethical Neutral"
              outlined
            ></v-text-field>
          </v-col>
          <v-col col="6" md="2">
            <v-text-field v-model="newNPC.Alignment.chaotic" label="Chaotic" outlined></v-text-field>
          </v-col>
        </v-row>
        <Inventory :Inventory="newNPC.Inventory" />
        <v-row>
          <v-col col="12">
            <v-textarea rows="4" v-model="newNPC.Notes" label="Summary" outlined></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col col="12">
            <v-text-field v-model="newNPC.hook" label="Plot Hook" outlined></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col col="12" md="6">
            <v-select
              v-model="TempTown"
              :items="AllTowns"
              item-text="Name"
              item-value="id"
              label="Relate to Town"
              outlined
              return-object
            ></v-select>
          </v-col>
          <v-col col="12" md="6">
            <v-text-field outlined v-model="newNPC.DndBeyondLink" label="Dnd Beyond Link"></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import db from "@/fb";
import firebase from "firebase/app";
import "firebase/auth";

import Inventory from "@/components/Inventory";

export default {
  components: { Inventory },
  data: () => ({
    TempTown: null,
    newNPC: { Abilities: {}, Alignment: {} },
    dialog: false,
    AllTowns: [],
  }),
  methods: {
    UpdateNPC() {
      this.newNPC.PlayerId = this.playerid;
      if (this.TempTown != null) {
        this.newNPC.Town.id = this.TempTown.id;
        this.newNPC.Town.Name = this.TempTown.Name;
      }
      this.newNPC.UpdateDate = firebase.firestore.FieldValue.serverTimestamp();
      db.collection("npcs")
        .doc(this.$route.params.id)
        .update(this.newNPC)
        .then(() => {
          this.$router.push({
            name: "NPC",
            params: { id: this.$route.params.id },
          });
        });
    },
  },
  firestore() {
    this.$bind(
      "AllTowns",
      db
        .collection("towns")
        .where("PlayerId", "==", firebase.auth().currentUser.uid)
    ).then((AllTowns) => {
      AllTowns.sort(function (a, b) {
        var textA = a.Name.toUpperCase();
        var textB = b.Name.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
    });
    this.$bind("newNPC", db.collection("npcs").doc(this.$route.params.id)).then(
      (newNPC) => {
        if (Object.keys(newNPC.Town).length != 0) {
          this.TempTown = newNPC.Town;
        }
      }
    );
  },

  created() {
    firebase.auth().onAuthStateChanged((cred) => {
      this.playerid = cred.uid;
    });
  },
};
</script>